<template>
    <div>
        <card-header title="Support Ticket Message" :subheader="user.first_name + ' ' + user.last_name" icon="fa-life-ring"></card-header>

        <card-toolbar>
            <button @click="openCard('support-ticket-new')"><i class="far fa-envelope-open-text"></i>New Ticket</button>

            <template v-slot:right>
                <button class="icon-only" @click="openCard('support-settings')"><i class="far fa-cog"></i></button>
            </template>
        </card-toolbar>

        <card-body subheader toolbar>
            <menu-list-item title="Clock hours for conference" note="Jul 24, 2020, 3:45pm" icon="fa-envelope"/>

            <card-container>
                <card-list>
                    <support-message-list-item @action="openCard('conference-details')"/>
                </card-list>
            </card-container>
        </card-body>
    </div>
</template>

<script>
    import CardHeader from "../../components/common/CardHeader";
    import CardBody from "../../components/common/CardBody";
    import CardToolbar from "../../components/common/CardToolbar";
    import CardContainer from "../../components/common/CardContainer";
    import CardSubheader from "../../components/common/CardSubheader";
    import DataRow from "../../components/common/DataRow";
    import CardList from "../../components/common/CardList";
    import SupportMessageListItem from "../../components/SupportMessageListItem";
    import MenuListItem from "../../components/MenuListItem";


    export default {
        components: {DataRow, CardSubheader, CardContainer, CardToolbar, CardBody, CardHeader, CardList, SupportMessageListItem, MenuListItem},

        methods: {
            openCard: function (card, props) {
                this.$emit('open', {card: card, props: props});
            }
        },
        data() {
            return {
                user: {
                    id: 249,
                    first_name: 'Scott',
                    last_name: 'Lamont'
                }
            }
        }
    }
</script>

<style>
    button {
        font-size: 13px !important
    }
</style>
